// import io from 'socket.io-client';
import { feathers } from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import authentication from '@feathersjs/authentication-client';
const io = require('socket.io-client');
import { Services } from 'src/types';
import { CustomServiceTypes } from './types/customServiceTypes';

// TODO: use https://github.com/feathersjs/feathers-configuration
const host = process.env.API_URL || 'http://localhost:3030';

export const socket = io(host, {
  transports: ['websocket'],
  forceNew: true
});

type ServiceNameLiteral = `${Services}`;

type ServiceTypes = {
  [key in Exclude<ServiceNameLiteral, keyof CustomServiceTypes>]: any; // Would be nice to fix this type at some point.
} & CustomServiceTypes;

const client = feathers<ServiceTypes>();

// NOTE: the order is important: auth must be configured _after_ rest/socket

client.configure(socketio(socket, { timeout: 5000, reconnectionDelayMax: 10000 }));

// Initialize custom methods
client.service('log').methods('getSpaceLog');
client.service('log').methods('generateRoomLogFileExport');
client.service('log').methods('generateMeetingSummary');
client.service('question').methods("getCalendarEvents");
client.service('meeting').methods("getCalendarEvents");
client.service('log').methods("checkInOut");
client.service('milestone').methods("getCalendarEvents");
client.service('deliverable').methods("getCalendarEvents");
client.service('session').methods('changeSpace');

// Configure authentication
client.configure(authentication({
  storage: window.localStorage
}));

// socket.on("connect", () => {
//   console.log('Socket.io connected')
// });

// socket.on("reconnect", (attempt:any) => {
//   console.log('Socket.io reconnect attempt', attempt)
// });

// socket.on("error", (error:any) => {
//   console.log('Socket.io error', error)
// });

// socket.on("connect_error", (error:any) => {
//   console.log('Socket.io connect_error', error)
// });

export default client;
